import { Injectable } from '@angular/core'
import { MbCheckoutAdapter } from './mb-checkout.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutConnector {

  constructor (protected adapter: MbCheckoutAdapter) {}

  redirectToPaymentPage (userId: string, cartId: string, termsChecked: boolean) {
    return this.adapter.redirectToPaymentPage(userId, cartId, termsChecked)
  }

  placeOrderWithPayment (userId: string, cartId: string, returnMac: string, hostedCheckoutId: string) {
    return this.adapter.placeOrderWithPayment(userId, cartId, returnMac, hostedCheckoutId)
  }

  resetIngenicoPayment (userId: string, cartId: string) {
    return this.adapter.resetIngenicoPayment(userId, cartId)
  }
}
